import React, { Component } from 'react';
import { connect } from 'react-redux';
import propTypes from 'prop-types';

// actions
import { changeActiveScriptInManage } from 'current';
import { requestManageScripts } from 'scripts/requesters';

// selectors
import {
  getActiveFieldId,
  getActiveProductYear,
  getActiveScriptId,
  getActiveScriptType
} from 'current/selectors';
import {
  areActiveFieldScriptsViewable,
  getScriptsForManageScriptList,
  getScriptById
} from 'scripts/selectors';

// components
import ScriptList from 'manage/ScriptList';

// Util
import { isEqual } from 'lodash';

class ScriptListContainer extends Component {

  componentDidMount() {
    this.props.onUpdate();
  }

  shouldComponentUpdate(nextProps, nextState) {
    return !isEqual(this.props, nextProps) || !isEqual(this.state, nextState);
  }

  componentDidUpdate(nextProps) {
    if(this.props.fieldId !== nextProps.fieldId) {
      this.props.onUpdate();
    }
  }

  onSelectScript = (scriptId) => {
    this.props.onClickScript(scriptId);
  };

  render() {
    return (
      <ScriptList
        onSelectScript={this.onSelectScript}
        {...this.props}
      />
    );
  }
}

ScriptListContainer.propTypes = {
  areActiveFieldScriptsViewable: propTypes.bool,
  fieldId: propTypes.string,
  onClickScript: propTypes.func.isRequired,
  onUpdate: propTypes.func.isRequired
};

ScriptListContainer = connect(
  (state) => {
    const activeScriptId = getActiveScriptId(state);
    return {
      areActiveFieldScriptsViewable: areActiveFieldScriptsViewable(state),
      fieldId: getActiveFieldId(state),
      productYear: getActiveProductYear(state),
      scriptId: activeScriptId,
      script: getScriptById(state, activeScriptId),
      scripts: getScriptsForManageScriptList(state),
      scriptType: getActiveScriptType(state)
    };
  },
  (dispatch) => {
    return {
      onClickScript: (scriptId) => {
        dispatch(changeActiveScriptInManage(scriptId));
      },
      onUpdate: () => {
        dispatch(requestManageScripts());
      }
    };
  }
)(ScriptListContainer);

export default ScriptListContainer;
